// extracted by mini-css-extract-plugin
export default {"line":"LabListItem_line__oWjSN","fio":"LabListItem_fio__o94k0"};